import React from "react";
import { EditionRecord, PrintRecord } from "../../BlakeData/Types";
import { ActiveIndex} from "../Types";
import { Dimensions } from "../Dimensions";
import { API } from "../../BlakeData";

import PseudoEditionView from "./PseudoEditionView";

interface EditionProps {
    edition: EditionRecord,
    activeIndex: ActiveIndex;
    setActiveIndex: (activeIndex: ActiveIndex) => void
    padding: number,
    paletteWidth: number,
    paletteHeight: number,
    hoverItemWidth: number,
    groupIndex: number;
    editionIndex: number;
    dimensions: Dimensions;
    groupVisible: boolean;

    displayYear: boolean;
}

interface EditionState {
    prints: Array<PrintRecord> | null;
    visible: boolean;
    segmentIndex: number;
}

export default class EditionView extends React.Component<EditionProps, {}>{

    state: EditionState;
    interactive: boolean = false;

    static defaultProps = {
        hoverItemWidth: 120,
        // padding: 2,
        // paletteWidth: 10,
        paletteHeight: 100
    }



    constructor(props: EditionProps) {
        super(props);

        this.state = {
            visible: true,
            // selectedItemIndex: 0,
            prints: null,
            segmentIndex: 0

            // prints: []
        }
        this.setValue = this.setValue.bind(this);

        API.getEditionPrints(this.props.edition).then((prints: Array<PrintRecord>) => { 
            // console.log("getEditionPrints", this.props.edition.id, prints.length)
            this.setState({ prints }) 
        })
    }

    setValue(idx: number | number[] | null | undefined) {
        // if (!this.interactive) { return }
        if (typeof idx !== "number") { return }
        const { groupIndex, editionIndex } = this.props;
        this.props.setActiveIndex({
            groupIndex,
            editionIndex,
            printIndex: idx
        });
        this.interactive = false;
    };

    render() {

        // TODO - fix this to at least return a placeholder
        // so the layout is blocked out before data loads
        // const fullPrintList = this.props.edition.prints
        // if (!this.state.prints) { return (null) }
        const fullPrintList = this.state.prints || this.props.edition.prints;
        if (!this.state.prints){ return (null)}

        // console.log(this.props.edition.id, fullPrintList.length)

        // determine the maximum number of prints 
        const chunkLength = Math.floor((this.props.dimensions.width - 40) / 12);

        // break the array into smaller arrays
        let chunkArrays = []
        for (var offset = 0; offset < fullPrintList.length; offset += chunkLength) {

            const start = offset;
            const stop = offset + chunkLength

            const chunk = fullPrintList.slice(offset, stop);
            // chunkArrays.push(chunk);
            chunkArrays.push({ start, stop: start + chunk.length })
        }

        return chunkArrays.map((span: { start: number, stop: number }, i) => {
            return <PseudoEditionView
                {...this.props}
                key={`${this.props.edition.id}-${i}`}
                start={span.start}
                stop={span.stop}
                allPrints={fullPrintList}
            />
        });
    }
}